import React from 'react';
import { Form, Row, Col } from "react-bootstrap";
import PropTypes from 'prop-types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Button, SvgIcon } from "@mui/material";
import CheckCircleWhiteIcon from '../../../icons/check-circle-white.svg?react'
import './StyledRadioInputWithBorder.scss';

function FancyButton(props) {

  const buttonClasses = `styledButton ${(props.active ? 'styledButtonActive' : 'styledButtonInactive')} ${(props.error ? 'styledButtonError' : '')}`;

  return (
    <Button id="radio-input" className={buttonClasses} variant="outlined" color="primary" fullWidth onClick={props.onClick} aria-describedby="radio-input" aria-invalid="true" disabled={props.disabled}>
      {props.icon && <div className='styledIcon me-2'>{props.icon}</div>}
      <div className='styledLabel'>{props.label}</div>
      <div className='styledCheck'>
        {props.active ? <CheckCircleIcon className="ms-3" htmlColor={props.active ? '' : '#bbb'} /> : <SvgIcon color="primary" component={CheckCircleWhiteIcon} />}
      </div>
    </Button>
  )
}

export default function StyledRadioInputWithBorder(props) {

  return (
    <div>
      {props.label && <legend className={`text-start ${props.labelCenter ? 'labelCenter' : 'label'}`}>{props.label}</legend>}
      <Row className='radio-input'>
        {props.options.map((x, i) => (
          <Col key={i} xs={props.colWidth ? props.colWidth : props.isTermQuoterPage ? 12 : 6} className={!props.isTermQuoterPage ? (i === 1 && !props.isTermHelpOptions) ? 'radioBtnRight' : 'radioBtnLeft' : ''}>
            <Form.Group>
              <FancyButton
                active={props.value === props.options[i].value}
                icon={props.options[i].icon}
                label={props.options[i].label}
                onClick={() => props.onChange(props.options[i].value)}
                error={!!props.errors}
                disabled={props.disabled}
              />
            </Form.Group>
          </Col>
        ))
        }
        {props.errors && <span className="MuiFormHelperText-root MuiFormHelperText-contained Mui-error d-block">{props.errors.message}</span>}
      </Row>
    </div>
  )
}

StyledRadioInputWithBorder.propTypes = {
  onChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  value: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.bool.isRequired,
    label: PropTypes.string.isRequired,
    icon: PropTypes.object,
  })),
}
